import { useStoreon } from "storeon/react";
import { IAppStore, IAppEvents } from "../store/appStore";

export const useAppStore = () => {
  const {
    appStore, dispatch: appStoreDispatch
  } = useStoreon<IAppStore, IAppEvents>("appStore");

  return { appStore, appStoreDispatch };
}